// Phase 2: Japanese, Simplified Chinese, Vietnamese, and Thai completion.
// Covers Phase 1 UI additions, fee-default settings, and legacy English fallbacks.
const phase2Completion = {
  ja: {
    "/notice/123 또는 https://...": "/notice/123 または https://...",
    "인포카드": "インフォカード",
    "인포카드 삭제": "インフォカードを削除",
    "인포카드 삭제 실패": "インフォカードの削除に失敗しました",
    "이 인포카드를 삭제하시겠습니까? 같은 카드의 데스크톱/모바일·언어별 변형도 함께 삭제됩니다. 테이블 그룹과 게임 테이블은 삭제되지 않습니다.": "このインフォカードを削除しますか？同じカードのデスクトップ／モバイル・言語別バリエーションもすべて削除されます。テーブルグループとゲームテーブルは削除されません。",
    "에이전트 수수료 기본값 설정": "エージェント手数料のデフォルト設定",
    "추천 코드 가입과 하위 계정 자동 생성 시 적용할 기본 수수료율을 설정합니다.": "紹介コードからの登録や下位アカウントの自動作成時に適用するデフォルト手数料率を設定します。",
    "현재 계정": "現在のアカウント",
    "현재 수수료": "現在の手数料",
    "설정 상태": "設定状態",
    "미설정": "未設定",
    "설정됨": "設定済み",
    "하위 에이전트 설정 방식": "下位エージェントの設定方式",
    "자율형과 고정 설정 중 하나를 선택합니다.": "自律型または固定設定のいずれかを選択します。",
    "자율형": "自律型",
    "직속 하위 에이전트에게 수수료율만 넘기고, 이후 하위 설정은 해당 에이전트가 직접 결정합니다.": "直属の下位エージェントには初期手数料率のみを渡し、それ以降の下位設定はそのエージェントが直接決定します。",
    "고정 설정": "固定設定",
    "현재 계정이 하위 에이전트와 유저 수수료를 모두 고정합니다. 하위 계정에는 설정 팝업이 표시되지 않습니다.": "現在のアカウントが下位エージェントとユーザーの手数料をすべて固定します。下位アカウントには設定ポップアップは表示されません。",
    "직속 유저": "直属ユーザー",
    "자율형 기본값": "自律型デフォルト値",
    "직속 하위 에이전트가 자동 생성될 때 적용할 최초 수수료율입니다.": "直属の下位エージェントが自動作成される際に適用する初期手数料率です。",
    "lv{from} → lv{to} 기본 수수료": "lv{from} → lv{to} デフォルト手数料",
    "하위 에이전트가 이후 자신의 하위 수수료를 직접 설정합니다.": "下位エージェントは、その後自分の配下の手数料を直接設定します。",
    "lv4는 추가 하위 에이전트가 없어 유저 가입 기본값만 설정합니다.": "lv4にはさらに下位のエージェントがないため、ユーザー登録のデフォルト値のみ設定します。",
    "전체 고정 기본값": "全体固定デフォルト値",
    "하위 계정이 생성되는 레벨에 따라 아래 값을 자동 적용합니다.": "下位アカウントが作成されるレベルに応じて、以下の値を自動適用します。",
    "lv{level} 고정 수수료": "lv{level} 固定手数料",
    "자동 생성되는 lv{level} 에이전트 노드에 적용됩니다.": "自動作成されるlv{level}エージェントノードに適用されます。",
    "유저 고정 레이크백": "ユーザー固定レーキバック",
    "고정 체인 아래에 생성되는 모든 신규 유저 노드에 적용됩니다.": "固定チェーン配下に作成されるすべての新規ユーザーノードに適用されます。",
    "고정 하위 경로 합계": "固定下位経路の合計",
    "유저 회원가입 타입": "ユーザー登録タイプ",
    "유저가 현재 에이전트의 추천 코드를 통해 직접 가입할 때 적용됩니다.": "ユーザーが現在のエージェントの紹介コードから直接登録する場合に適用されます。",
    "추천인 가입 유저 기본 수수료": "紹介登録ユーザーのデフォルト手数料",
    "고정 설정의 유저 값과 자동으로 동일하게 유지됩니다.": "固定設定のユーザー値と自動的に同じ値に保たれます。",
    "lv{level} → 유저로 직접 연결될 때 적용됩니다.": "lv{level} → ユーザーへ直接接続される場合に適用されます。",
    "적용 방식": "適用方式",
    "직접 가입 유저": "直接登録ユーザー",
    "상위 고정 정책이 적용된 하위 에이전트는 별도의 기본값 설정 팝업을 보지 않습니다.": "上位の固定ポリシーが適用されている下位エージェントには、個別のデフォルト設定ポップアップは表示されません。",
    "하위 에이전트는 자신이 로그인한 뒤 다음 단계의 기본값을 별도로 설정할 수 있습니다.": "下位エージェントはログイン後、次の階層のデフォルト値を個別に設定できます。",
    "수수료 기본값 저장에 실패했습니다.": "手数料のデフォルト値の保存に失敗しました。",
    "나중에 설정": "後で設定",
    "기본값 저장": "デフォルト値を保存",
    "직접 입력": "手動入力",
    "수수료 기본값 설정": "手数料のデフォルト値を設定",
    "수수료 기본값 수정": "手数料のデフォルト値を編集",
    "상위 고정 설정 적용 중": "上位の固定設定を適用中",
    "0.01 이상의 금액을 소수 둘째 자리까지 입력해 주세요.": "0.01以上の金額を小数第2位まで入力してください。",
    "보유한 레이크백보다 큰 금액은 이동할 수 없습니다.": "保有しているレーキバックを超える金額は移動できません。",
    "레이크백을 일반 자산으로 이동했습니다.": "レーキバックを通常資産へ移動しました。",
    "레이크백 이동에 실패했습니다.": "レーキバックの移動に失敗しました。",
    "자산으로 이동": "資産へ移動",
    "레이크백 → 일반 자산": "レーキバック → 通常資産",
    "이동할 금액만큼 레이크백이 차감되고 일반 자산에 즉시 추가됩니다.": "移動額分のレーキバックが差し引かれ、通常資産に即時追加されます。",
    "보유 레이크백": "保有レーキバック",
    "현재 일반 자산": "現在の通常資産",
    "이동 금액": "移動金額",
    "전액": "全額",
    "이동 중...": "移動中...",
    "소수 둘째 자리까지 입력 가능": "小数第2位まで入力可能",
    "0.01 ~ 1,000,000,000.00 범위의 금액을 소수 둘째 자리까지 입력하세요.": "0.01～1,000,000,000.00の範囲で、小数第2位までの金額を入力してください。",
    "유저": "ユーザー",
    "디자인 이미지": "デザイン画像",
    "디자인": "デザイン",
    "실제 비율 미리보기": "実際の比率でプレビュー",
    "결제 항목 금액은 0보다 크고 소수 둘째 자리까지만 입력할 수 있습니다.": "決済項目の金額は0より大きく、小数第2位まで入力できます。",
    "지급이 처리되지 않았습니다.": "支給処理が完了しませんでした。",
    "차감이 처리되지 않았습니다.": "差し引き処理が完了しませんでした。",
    "단독 인포버튼": "単独インフォボタン",
    "단독 인포버튼 생성 실패": "単独インフォボタンの作成に失敗しました",
    "+ 인포버튼 단독 생성": "+ 単独インフォボタンを作成",
    "인포버튼 단독 생성": "単独インフォボタンを作成",
    "현재 디자인 배치와 다국어 문구를 기본값으로 초기화할까요?": "現在のデザイン配置と多言語文言をデフォルト値にリセットしますか？",
    "이미지 파일만 업로드할 수 있습니다.": "画像ファイルのみアップロードできます。",
    "배경 이미지 업로드에 실패했습니다.": "背景画像のアップロードに失敗しました。",
    "요소 이미지 업로드에 실패했습니다.": "要素画像のアップロードに失敗しました。",
    "이벤트 카드 디자인 · 광고 편집기 방식": "イベントカードデザイン · 広告エディター方式",
    "하단 이벤트 카드 자체를 배경 이미지 + 자유 배치 + 요소 이미지 + 언어별 구분자 텍스트 방식으로 편집합니다.": "下部のイベントカード自体を、背景画像＋自由配置＋要素画像＋言語別区切りテキスト方式で編集します。",
    "기존 하이라이트 문구 불러오기": "既存のハイライト文言を読み込む",
    "디자인 초기화": "デザインをリセット",
    "새 디자인 사용": "新しいデザインを使用",
    "편집 디바이스": "編集デバイス",
    "렌더링 방식": "レンダリング方式",
    "배경 + HTML/CSS 요소": "背景 + HTML/CSS要素",
    "이미지만 표시": "画像のみ表示",
    "배경 이미지 맞춤": "背景画像のフィット",
    "COVER · 영역 채우기": "COVER · 領域を埋める",
    "CONTAIN · 전체 표시": "CONTAIN · 全体を表示",
    "FILL · 강제 맞춤": "FILL · 強制フィット",
    "배경 이미지": "背景画像",
    "업로드 중...": "アップロード中...",
    "로컬 이미지 업로드": "ローカル画像をアップロード",
    "배경 제거": "背景を削除",
    "업로드하면 /uploads/info-backgrounds/... 로 자동 입력됩니다.": "アップロードすると /uploads/info-backgrounds/... が自動入力されます。",
    "요소 이미지 업로드 중...": "要素画像をアップロード中...",
    "배경 이미지 미리보기": "背景画像プレビュー",
    "입력 내용이 미리보기에 자동 반영됨": "入力内容はプレビューに自動反映されます",
    "언어별 문구 적용 완료 · {count}개 언어 감지": "言語別文言を適用しました · {count}言語を検出",
    "텍스트 {number}": "テキスト {number}",
    "요소 이미지는 파일당 10MB 이하만 가능해.": "要素画像は1ファイル10MB以下のみ使用できます。",
    "추가 텍스트": "追加テキスト",
    "요소 이미지": "要素画像",
    "요소": "要素",
    "배너 레이아웃·다국어 편집": "バナーレイアウト・多言語編集",
    "각 텍스트 요소에 언어별 문구를 한 칸에 통으로 입력하고, 배경 외 장식 이미지도 로컬에서 추가할 수 있습니다.": "各テキスト要素に言語別文言を1つの欄へまとめて入力し、背景とは別に装飾画像もローカルから追加できます。",
    "클라이언트 언어별 미리보기": "クライアント言語別プレビュー",
    "미리보기: {language}": "プレビュー: {language}",
    "번역이 없을 때 사용할 언어": "翻訳がない場合に使用する言語",
    "기본: {language}": "デフォルト: {language}",
    "편집 화면 {value}%": "編集画面 {value}%",
    "확대된 캔버스에서 요소를 끌어 배치합니다. 좌표는 배너 내부 백분율로 저장되어 같은 기기 프로필 안에서 창 크기에 맞춰 함께 축소·확대됩니다.": "拡大されたキャンバス上で要素をドラッグして配置します。座標はバナー内の割合で保存され、同じデバイスプロファイル内でウィンドウサイズに合わせて一緒に拡大・縮小されます。",
    "텍스트 요소별 통합 다국어 입력": "テキスト要素別の統合多言語入力",
    "구분자는 줄바꿈, |, 쉼표를 사용할 수 있습니다. 예: 한국어:지금 바로 | 영어:Right now | 일본어:今すぐ": "区切り文字には改行、|、カンマを使用できます。例: 韓国語:지금 바로 | 英語:Right now | 日本語:今すぐ",
    "언어별 찾아서 적용": "言語別に検出して適用",
    "한국어:문구 | 영어:Text | 일본어:テキ스트": "韓国語:문구 | 英語:Text | 日本語:テキスト",
    "추가 텍스트 요소": "追加テキスト要素",
    "+ 텍스트 요소 추가": "+ テキスト要素を追加",
    "추가 텍스트가 없습니다. 필요한 개수만큼 요소를 추가하세요.": "追加テキストはありません。必要な数だけ要素を追加してください。",
    "한국어:지금 바로 | 영어:Right now": "韓国語:지금 바로 | 英語:Right now",
    "캔버스에서 이 텍스트 선택": "キャンバス上でこのテキストを選択",
    "가로 중심": "水平方向の中央",
    "세로 중심": "垂直方向の中央",
    "확대": "拡大率",
    "이미지 투명도": "画像の不透明度",
    "텍스트 가독성 오버레이": "テキスト可読性オーバーレイ",
    "요소 이미지 업로드": "要素画像をアップロード",
    "+ 로컬 이미지 추가": "+ ローカル画像を追加",
    "배경과 별도로 로고, 카드, 칩, 아이콘 등을 여러 개 추가하고 각각 위치·크기를 조절할 수 있습니다.": "背景とは別にロゴ、カード、チップ、アイコンなどを複数追加し、それぞれの位置とサイズを調整できます。",
    "이미지 요소": "画像要素",
    "기본 요소 선택": "基本要素を選択",
    "{element} 위치·크기": "{element} の位置・サイズ",
    "너비": "幅",
    "높이": "高さ",
    "기준 글자 크기": "基準フォントサイズ",
    "투명도": "不透明度",
    "회전": "回転",
    "왼쪽": "左",
    "가운데": "中央",
    "오른쪽": "右",
    "글자색": "文字色",
    "이미지 맞춤": "画像フィット",
    "전체 표시 · contain": "全体表示 · contain",
    "영역 채우기 · cover": "領域を埋める · cover",
    "강제 맞춤 · fill": "強制フィット · fill",
    "클라이언트에 표시": "クライアントに表示",
    "이 텍스트 요소 삭제": "このテキスト要素を削除",
    "이 이미지 요소 삭제": "この画像要素を削除",
    "프로필 좌표 복사": "プロファイル座標をコピー",
    "{profile}에서 복사": "{profile} からコピー",
    "링크는 http://, https:// 또는 / 로 시작하는 내부 경로여야 해.": "リンクは http://、https://、または / で始まる内部パスである必要があります。",
    "1 row = 1 area + 1 device + 1 country + 1 background image · 저장 1건은 별도의 광고 1건": "1 row = 1 area + 1 device + 1 country + 1 background image · 1件の保存は1件の独立した広告です",
    "배너 렌더링 방식": "バナーのレンダリング方式",
    "배경 이미지 + 다국어 HTML/CSS 요소": "背景画像 + 多言語HTML/CSS要素",
    "이미지 전체만 표시": "画像全体のみ表示",
    "이미지 전체 표시 · contain": "画像全体を表示 · contain",
    "https://... 또는 /lounge": "https://... または /lounge",
    "비워두면 이동 없음 · 외부 URL 또는 /lounge 같은 내부 경로 사용 가능": "空欄の場合は移動しません · 外部URLまたは /lounge のような内部パスを使用できます",
    "이미지 전체 표시 방식에서는 업로드한 이미지가 그대로 노출됩니다. 좌표·다국어 요소 편집은 배경 이미지 + HTML/CSS 방식을 선택할 때 사용합니다.": "画像全体表示方式では、アップロードした画像がそのまま表示されます。座標・多言語要素の編集は「背景画像 + HTML/CSS」方式を選択した場合に使用します。",
    "저장 1건 = 별도의 광고 1건 · area/device/country별로 각각 관리": "1件の保存 = 1件の独立した広告 · area/device/countryごとに個別管理",
    "배지": "バッジ",
    "보상": "報酬",
    "설명": "説明",
    "버튼": "ボタン",
    "배지 상단": "バッジ上部",
    "배지 하단": "バッジ下部",
    "강조 제목": "強調タイトル",
    "보상 문구": "報酬文言"
  },
  zh: {
    "/notice/123 또는 https://...": "/notice/123 或 https://...",
    "인포카드": "信息卡",
    "인포카드 삭제": "删除信息卡",
    "인포카드 삭제 실패": "删除信息卡失败",
    "이 인포카드를 삭제하시겠습니까? 같은 카드의 데스크톱/모바일·언어별 변형도 함께 삭제됩니다. 테이블 그룹과 게임 테이블은 삭제되지 않습니다.": "确定要删除此信息卡吗？同一卡片的桌面端/移动端及各语言版本也会一并删除。桌台组和游戏桌不会被删除。",
    "에이전트 수수료 기본값 설정": "代理手续费默认设置",
    "추천 코드 가입과 하위 계정 자동 생성 시 적용할 기본 수수료율을 설정합니다.": "设置通过推荐码注册及自动创建下级账户时应用的默认手续费率。",
    "현재 계정": "当前账户",
    "현재 수수료": "当前手续费",
    "설정 상태": "设置状态",
    "미설정": "未设置",
    "설정됨": "已设置",
    "하위 에이전트 설정 방식": "下级代理设置方式",
    "자율형과 고정 설정 중 하나를 선택합니다.": "请选择自主模式或固定设置。",
    "자율형": "自主模式",
    "직속 하위 에이전트에게 수수료율만 넘기고, 이후 하위 설정은 해당 에이전트가 직접 결정합니다.": "仅向直属下级代理下发初始手续费率，之后的下级设置由该代理自行决定。",
    "고정 설정": "固定设置",
    "현재 계정이 하위 에이전트와 유저 수수료를 모두 고정합니다. 하위 계정에는 설정 팝업이 표시되지 않습니다.": "当前账户会固定所有下级代理和用户的手续费。下级账户不会显示设置弹窗。",
    "직속 유저": "直属用户",
    "자율형 기본값": "自主模式默认值",
    "직속 하위 에이전트가 자동 생성될 때 적용할 최초 수수료율입니다.": "直属下级代理自动创建时应用的初始手续费率。",
    "lv{from} → lv{to} 기본 수수료": "lv{from} → lv{to} 默认手续费",
    "하위 에이전트가 이후 자신의 하위 수수료를 직접 설정합니다.": "下级代理之后可自行设置其下级手续费。",
    "lv4는 추가 하위 에이전트가 없어 유저 가입 기본값만 설정합니다.": "lv4没有更下一级代理，因此只设置用户注册默认值。",
    "전체 고정 기본값": "全局固定默认值",
    "하위 계정이 생성되는 레벨에 따라 아래 값을 자동 적용합니다.": "根据创建的下级账户等级自动应用以下数值。",
    "lv{level} 고정 수수료": "lv{level} 固定手续费",
    "자동 생성되는 lv{level} 에이전트 노드에 적용됩니다.": "应用于自动创建的lv{level}代理节点。",
    "유저 고정 레이크백": "用户固定返水",
    "고정 체인 아래에 생성되는 모든 신규 유저 노드에 적용됩니다.": "应用于固定链路下创建的所有新用户节点。",
    "고정 하위 경로 합계": "固定下级路径合计",
    "유저 회원가입 타입": "用户注册类型",
    "유저가 현재 에이전트의 추천 코드를 통해 직접 가입할 때 적용됩니다.": "用户通过当前代理的推荐码直接注册时应用。",
    "추천인 가입 유저 기본 수수료": "推荐注册用户默认手续费",
    "고정 설정의 유저 값과 자동으로 동일하게 유지됩니다.": "会自动与固定设置中的用户数值保持一致。",
    "lv{level} → 유저로 직접 연결될 때 적용됩니다.": "当用户直接连接到lv{level}下时应用。",
    "적용 방식": "应用方式",
    "직접 가입 유저": "直接注册用户",
    "상위 고정 정책이 적용된 하위 에이전트는 별도의 기본값 설정 팝업을 보지 않습니다.": "受上级固定策略约束的下级代理不会看到单独的默认设置弹窗。",
    "하위 에이전트는 자신이 로그인한 뒤 다음 단계의 기본값을 별도로 설정할 수 있습니다.": "下级代理登录后可单独设置下一层级的默认值。",
    "수수료 기본값 저장에 실패했습니다.": "保存手续费默认值失败。",
    "나중에 설정": "稍后设置",
    "기본값 저장": "保存默认值",
    "직접 입력": "手动输入",
    "수수료 기본값 설정": "设置手续费默认值",
    "수수료 기본값 수정": "修改手续费默认值",
    "상위 고정 설정 적용 중": "正在应用上级固定设置",
    "0.01 이상의 금액을 소수 둘째 자리까지 입력해 주세요.": "请输入不低于0.01且最多保留两位小数的金额。",
    "보유한 레이크백보다 큰 금액은 이동할 수 없습니다.": "转移金额不能超过当前可用返水。",
    "레이크백을 일반 자산으로 이동했습니다.": "返水已转入普通资产。",
    "레이크백 이동에 실패했습니다.": "转移返水失败。",
    "자산으로 이동": "转入资产",
    "레이크백 → 일반 자산": "返水 → 普通资产",
    "이동할 금액만큼 레이크백이 차감되고 일반 자산에 즉시 추가됩니다.": "转移的金额会从返水中扣除，并立即加入普通资产。",
    "보유 레이크백": "可用返水",
    "현재 일반 자산": "当前普通资产",
    "이동 금액": "转移金额",
    "전액": "全部",
    "이동 중...": "正在转移...",
    "소수 둘째 자리까지 입력 가능": "最多可输入两位小数",
    "0.01 ~ 1,000,000,000.00 범위의 금액을 소수 둘째 자리까지 입력하세요.": "请输入0.01至1,000,000,000.00范围内且最多保留两位小数的金额。",
    "유저": "用户",
    "디자인 이미지": "设计图片",
    "디자인": "设计",
    "실제 비율 미리보기": "实际比例预览",
    "결제 항목 금액은 0보다 크고 소수 둘째 자리까지만 입력할 수 있습니다.": "支付项目金额必须大于0，且最多只能输入两位小数。",
    "지급이 처리되지 않았습니다.": "发放未处理。",
    "차감이 처리되지 않았습니다.": "扣除未处理。",
    "단독 인포버튼": "独立信息按钮",
    "단독 인포버튼 생성 실패": "创建独立信息按钮失败",
    "+ 인포버튼 단독 생성": "+ 创建独立信息按钮",
    "인포버튼 단독 생성": "创建独立信息按钮",
    "현재 디자인 배치와 다국어 문구를 기본값으로 초기화할까요?": "是否将当前设计布局和多语言文案重置为默认值？",
    "이미지 파일만 업로드할 수 있습니다.": "只能上传图片文件。",
    "배경 이미지 업로드에 실패했습니다.": "上传背景图片失败。",
    "요소 이미지 업로드에 실패했습니다.": "上传元素图片失败。",
    "이벤트 카드 디자인 · 광고 편집기 방식": "活动卡片设计 · 广告编辑器模式",
    "하단 이벤트 카드 자체를 배경 이미지 + 자유 배치 + 요소 이미지 + 언어별 구분자 텍스트 방식으로 편집합니다.": "使用背景图片 + 自由布局 + 元素图片 + 按语言分隔文本的方式编辑下方活动卡片本身。",
    "기존 하이라이트 문구 불러오기": "加载现有高亮文案",
    "디자인 초기화": "重置设计",
    "새 디자인 사용": "使用新设计",
    "편집 디바이스": "编辑设备",
    "렌더링 방식": "渲染方式",
    "배경 + HTML/CSS 요소": "背景 + HTML/CSS元素",
    "이미지만 표시": "仅显示图片",
    "배경 이미지 맞춤": "背景图片适配",
    "COVER · 영역 채우기": "COVER · 填满区域",
    "CONTAIN · 전체 표시": "CONTAIN · 完整显示",
    "FILL · 강제 맞춤": "FILL · 强制拉伸",
    "배경 이미지": "背景图片",
    "업로드 중...": "正在上传...",
    "로컬 이미지 업로드": "上传本地图片",
    "배경 제거": "移除背景",
    "업로드하면 /uploads/info-backgrounds/... 로 자동 입력됩니다.": "上传后会自动填入 /uploads/info-backgrounds/...。",
    "요소 이미지 업로드 중...": "正在上传元素图片...",
    "배경 이미지 미리보기": "背景图片预览",
    "입력 내용이 미리보기에 자동 반영됨": "输入内容会自动反映到预览中",
    "언어별 문구 적용 완료 · {count}개 언어 감지": "已应用各语言文案 · 检测到{count}种语言",
    "텍스트 {number}": "文本 {number}",
    "요소 이미지는 파일당 10MB 이하만 가능해.": "每个元素图片文件必须不超过10MB。",
    "추가 텍스트": "附加文本",
    "요소 이미지": "元素图片",
    "요소": "元素",
    "배너 레이아웃·다국어 편집": "横幅布局 · 多语言编辑",
    "각 텍스트 요소에 언어별 문구를 한 칸에 통으로 입력하고, 배경 외 장식 이미지도 로컬에서 추가할 수 있습니다.": "可在每个文本元素的一个输入框中统一输入各语言文案，并可从本地添加背景之外的装饰图片。",
    "클라이언트 언어별 미리보기": "按客户端语言预览",
    "미리보기: {language}": "预览：{language}",
    "번역이 없을 때 사용할 언어": "缺少翻译时使用的语言",
    "기본: {language}": "默认：{language}",
    "편집 화면 {value}%": "编辑画面 {value}%",
    "확대된 캔버스에서 요소를 끌어 배치합니다. 좌표는 배너 내부 백분율로 저장되어 같은 기기 프로필 안에서 창 크기에 맞춰 함께 축소·확대됩니다.": "在放大的画布上拖动元素进行布局。坐标以横幅内部百分比保存，因此在同一设备配置中会随窗口大小同比缩放。",
    "텍스트 요소별 통합 다국어 입력": "按文本元素统一输入多语言内容",
    "구분자는 줄바꿈, |, 쉼표를 사용할 수 있습니다. 예: 한국어:지금 바로 | 영어:Right now | 일본어:今すぐ": "分隔符可使用换行、| 或逗号。例如：韩语:지금 바로 | 英语:Right now | 日语:今すぐ",
    "언어별 찾아서 적용": "按语言检测并应用",
    "한국어:문구 | 영어:Text | 일본어:テキ스트": "韩语:문구 | 英语:Text | 日语:テキスト",
    "추가 텍스트 요소": "附加文本元素",
    "+ 텍스트 요소 추가": "+ 添加文本元素",
    "추가 텍스트가 없습니다. 필요한 개수만큼 요소를 추가하세요.": "没有附加文本。请按需要添加相应数量的元素。",
    "한국어:지금 바로 | 영어:Right now": "韩语:지금 바로 | 英语:Right now",
    "캔버스에서 이 텍스트 선택": "在画布中选择此文本",
    "가로 중심": "水平居中",
    "세로 중심": "垂直居中",
    "확대": "缩放",
    "이미지 투명도": "图片不透明度",
    "텍스트 가독성 오버레이": "文本可读性遮罩",
    "요소 이미지 업로드": "上传元素图片",
    "+ 로컬 이미지 추가": "+ 添加本地图片",
    "배경과 별도로 로고, 카드, 칩, 아이콘 등을 여러 개 추가하고 각각 위치·크기를 조절할 수 있습니다.": "可在背景之外添加多个Logo、卡片、筹码、图标等，并分别调整位置和大小。",
    "이미지 요소": "图片元素",
    "기본 요소 선택": "选择基础元素",
    "{element} 위치·크기": "{element} 位置·大小",
    "너비": "宽度",
    "높이": "高度",
    "기준 글자 크기": "基准字号",
    "투명도": "不透明度",
    "회전": "旋转",
    "왼쪽": "左",
    "가운데": "居中",
    "오른쪽": "右",
    "글자색": "文字颜色",
    "이미지 맞춤": "图片适配",
    "전체 표시 · contain": "完整显示 · contain",
    "영역 채우기 · cover": "填满区域 · cover",
    "강제 맞춤 · fill": "强制拉伸 · fill",
    "클라이언트에 표시": "在客户端显示",
    "이 텍스트 요소 삭제": "删除此文本元素",
    "이 이미지 요소 삭제": "删除此图片元素",
    "프로필 좌표 복사": "复制配置坐标",
    "{profile}에서 복사": "从{profile}复制",
    "링크는 http://, https:// 또는 / 로 시작하는 내부 경로여야 해.": "链接必须以 http://、https:// 或 / 开头的内部路径形式填写。",
    "1 row = 1 area + 1 device + 1 country + 1 background image · 저장 1건은 별도의 광고 1건": "1 row = 1 area + 1 device + 1 country + 1 background image · 每次保存对应一条独立广告",
    "배너 렌더링 방식": "横幅渲染方式",
    "배경 이미지 + 다국어 HTML/CSS 요소": "背景图片 + 多语言HTML/CSS元素",
    "이미지 전체만 표시": "仅显示完整图片",
    "이미지 전체 표시 · contain": "完整显示图片 · contain",
    "https://... 또는 /lounge": "https://... 或 /lounge",
    "비워두면 이동 없음 · 외부 URL 또는 /lounge 같은 내부 경로 사용 가능": "留空则不跳转 · 可使用外部URL或 /lounge 之类的内部路径",
    "이미지 전체 표시 방식에서는 업로드한 이미지가 그대로 노출됩니다. 좌표·다국어 요소 편집은 배경 이미지 + HTML/CSS 방식을 선택할 때 사용합니다.": "在完整图片显示模式下，上传的图片会原样展示。坐标和多语言元素编辑仅在选择“背景图片 + HTML/CSS”模式时使用。",
    "저장 1건 = 별도의 광고 1건 · area/device/country별로 각각 관리": "每次保存 = 一条独立广告 · 按area/device/country分别管理",
    "배지": "徽章",
    "보상": "奖励",
    "설명": "说明",
    "버튼": "按钮",
    "배지 상단": "徽章上方",
    "배지 하단": "徽章下方",
    "강조 제목": "强调标题",
    "보상 문구": "奖励文案"
  },
  vi: {
    "/notice/123 또는 https://...": "/notice/123 hoặc https://...",
    "인포카드": "Thẻ thông tin",
    "인포카드 삭제": "Xóa thẻ thông tin",
    "인포카드 삭제 실패": "Không thể xóa thẻ thông tin",
    "이 인포카드를 삭제하시겠습니까? 같은 카드의 데스크톱/모바일·언어별 변형도 함께 삭제됩니다. 테이블 그룹과 게임 테이블은 삭제되지 않습니다.": "Bạn có muốn xóa thẻ thông tin này không? Tất cả biến thể desktop/mobile và theo ngôn ngữ của cùng thẻ cũng sẽ bị xóa. Nhóm bàn và các bàn chơi sẽ không bị xóa.",
    "에이전트 수수료 기본값 설정": "Cài đặt phí mặc định của đại lý",
    "추천 코드 가입과 하위 계정 자동 생성 시 적용할 기본 수수료율을 설정합니다.": "Thiết lập tỷ lệ phí mặc định áp dụng khi đăng ký bằng mã giới thiệu và khi tự động tạo tài khoản cấp dưới.",
    "현재 계정": "Tài khoản hiện tại",
    "현재 수수료": "Phí hiện tại",
    "설정 상태": "Trạng thái cài đặt",
    "미설정": "Chưa cài đặt",
    "설정됨": "Đã cài đặt",
    "하위 에이전트 설정 방식": "Chế độ cài đặt đại lý cấp dưới",
    "자율형과 고정 설정 중 하나를 선택합니다.": "Chọn chế độ tự chủ hoặc cài đặt cố định.",
    "자율형": "Tự chủ",
    "직속 하위 에이전트에게 수수료율만 넘기고, 이후 하위 설정은 해당 에이전트가 직접 결정합니다.": "Chỉ chuyển tỷ lệ phí ban đầu cho đại lý cấp dưới trực tiếp; các thiết lập cấp dưới tiếp theo do đại lý đó tự quyết định.",
    "고정 설정": "Cài đặt cố định",
    "현재 계정이 하위 에이전트와 유저 수수료를 모두 고정합니다. 하위 계정에는 설정 팝업이 표시되지 않습니다.": "Tài khoản hiện tại cố định toàn bộ phí của đại lý cấp dưới và người dùng. Tài khoản cấp dưới sẽ không thấy cửa sổ cài đặt.",
    "직속 유저": "Người dùng trực tiếp",
    "자율형 기본값": "Giá trị mặc định tự chủ",
    "직속 하위 에이전트가 자동 생성될 때 적용할 최초 수수료율입니다.": "Đây là tỷ lệ phí ban đầu áp dụng khi đại lý cấp dưới trực tiếp được tạo tự động.",
    "lv{from} → lv{to} 기본 수수료": "Phí mặc định lv{from} → lv{to}",
    "하위 에이전트가 이후 자신의 하위 수수료를 직접 설정합니다.": "Sau đó, đại lý cấp dưới sẽ tự thiết lập phí cho cấp dưới của mình.",
    "lv4는 추가 하위 에이전트가 없어 유저 가입 기본값만 설정합니다.": "lv4 không có đại lý cấp dưới tiếp theo, vì vậy chỉ thiết lập giá trị mặc định khi người dùng đăng ký.",
    "전체 고정 기본값": "Giá trị mặc định cố định toàn bộ",
    "하위 계정이 생성되는 레벨에 따라 아래 값을 자동 적용합니다.": "Tự động áp dụng các giá trị bên dưới theo cấp của tài khoản cấp dưới được tạo.",
    "lv{level} 고정 수수료": "Phí cố định lv{level}",
    "자동 생성되는 lv{level} 에이전트 노드에 적용됩니다.": "Áp dụng cho nút đại lý lv{level} được tạo tự động.",
    "유저 고정 레이크백": "Rakeback cố định của người dùng",
    "고정 체인 아래에 생성되는 모든 신규 유저 노드에 적용됩니다.": "Áp dụng cho mọi nút người dùng mới được tạo dưới chuỗi cố định.",
    "고정 하위 경로 합계": "Tổng đường dẫn cấp dưới cố định",
    "유저 회원가입 타입": "Loại đăng ký người dùng",
    "유저가 현재 에이전트의 추천 코드를 통해 직접 가입할 때 적용됩니다.": "Áp dụng khi người dùng đăng ký trực tiếp bằng mã giới thiệu của đại lý hiện tại.",
    "추천인 가입 유저 기본 수수료": "Phí mặc định cho người dùng đăng ký qua giới thiệu",
    "고정 설정의 유저 값과 자동으로 동일하게 유지됩니다.": "Tự động giữ cùng giá trị với giá trị người dùng trong cài đặt cố định.",
    "lv{level} → 유저로 직접 연결될 때 적용됩니다.": "Áp dụng khi người dùng được kết nối trực tiếp dưới lv{level}.",
    "적용 방식": "Cách áp dụng",
    "직접 가입 유저": "Người dùng đăng ký trực tiếp",
    "상위 고정 정책이 적용된 하위 에이전트는 별도의 기본값 설정 팝업을 보지 않습니다.": "Đại lý cấp dưới chịu chính sách cố định từ cấp trên sẽ không thấy cửa sổ cài đặt mặc định riêng.",
    "하위 에이전트는 자신이 로그인한 뒤 다음 단계의 기본값을 별도로 설정할 수 있습니다.": "Sau khi đăng nhập, đại lý cấp dưới có thể thiết lập riêng giá trị mặc định cho cấp tiếp theo.",
    "수수료 기본값 저장에 실패했습니다.": "Không thể lưu giá trị phí mặc định.",
    "나중에 설정": "Cài đặt sau",
    "기본값 저장": "Lưu giá trị mặc định",
    "직접 입력": "Nhập thủ công",
    "수수료 기본값 설정": "Thiết lập phí mặc định",
    "수수료 기본값 수정": "Chỉnh sửa phí mặc định",
    "상위 고정 설정 적용 중": "Đang áp dụng cài đặt cố định từ cấp trên",
    "0.01 이상의 금액을 소수 둘째 자리까지 입력해 주세요.": "Nhập số tiền từ 0.01 trở lên, tối đa hai chữ số thập phân.",
    "보유한 레이크백보다 큰 금액은 이동할 수 없습니다.": "Không thể chuyển nhiều hơn số rakeback hiện có.",
    "레이크백을 일반 자산으로 이동했습니다.": "Đã chuyển rakeback sang tài sản thông thường.",
    "레이크백 이동에 실패했습니다.": "Không thể chuyển rakeback.",
    "자산으로 이동": "Chuyển sang tài sản",
    "레이크백 → 일반 자산": "Rakeback → Tài sản thông thường",
    "이동할 금액만큼 레이크백이 차감되고 일반 자산에 즉시 추가됩니다.": "Số tiền chuyển sẽ được trừ khỏi rakeback và cộng ngay vào tài sản thông thường.",
    "보유 레이크백": "Rakeback hiện có",
    "현재 일반 자산": "Tài sản thông thường hiện tại",
    "이동 금액": "Số tiền chuyển",
    "전액": "Toàn bộ",
    "이동 중...": "Đang chuyển...",
    "소수 둘째 자리까지 입력 가능": "Có thể nhập tối đa hai chữ số thập phân",
    "0.01 ~ 1,000,000,000.00 범위의 금액을 소수 둘째 자리까지 입력하세요.": "Nhập số tiền từ 0.01 đến 1,000,000,000.00 với tối đa hai chữ số thập phân.",
    "유저": "Người dùng",
    "디자인 이미지": "Ảnh thiết kế",
    "디자인": "Thiết kế",
    "실제 비율 미리보기": "Xem trước theo tỷ lệ thực",
    "결제 항목 금액은 0보다 크고 소수 둘째 자리까지만 입력할 수 있습니다.": "Số tiền của mục thanh toán phải lớn hơn 0 và chỉ được nhập tối đa hai chữ số thập phân.",
    "지급이 처리되지 않았습니다.": "Khoản cấp phát chưa được xử lý.",
    "차감이 처리되지 않았습니다.": "Khoản khấu trừ chưa được xử lý.",
    "단독 인포버튼": "Nút thông tin độc lập",
    "단독 인포버튼 생성 실패": "Không thể tạo nút thông tin độc lập",
    "+ 인포버튼 단독 생성": "+ Tạo nút thông tin độc lập",
    "인포버튼 단독 생성": "Tạo nút thông tin độc lập",
    "현재 디자인 배치와 다국어 문구를 기본값으로 초기화할까요?": "Đặt lại bố cục thiết kế hiện tại và nội dung đa ngôn ngữ về mặc định?",
    "이미지 파일만 업로드할 수 있습니다.": "Chỉ có thể tải lên tệp hình ảnh.",
    "배경 이미지 업로드에 실패했습니다.": "Không thể tải ảnh nền lên.",
    "요소 이미지 업로드에 실패했습니다.": "Không thể tải ảnh phần tử lên.",
    "이벤트 카드 디자인 · 광고 편집기 방식": "Thiết kế thẻ sự kiện · Chế độ trình chỉnh sửa quảng cáo",
    "하단 이벤트 카드 자체를 배경 이미지 + 자유 배치 + 요소 이미지 + 언어별 구분자 텍스트 방식으로 편집합니다.": "Chỉnh sửa trực tiếp thẻ sự kiện phía dưới bằng ảnh nền + bố cục tự do + ảnh phần tử + văn bản phân tách theo ngôn ngữ.",
    "기존 하이라이트 문구 불러오기": "Tải nội dung nổi bật hiện có",
    "디자인 초기화": "Đặt lại thiết kế",
    "새 디자인 사용": "Dùng thiết kế mới",
    "편집 디바이스": "Thiết bị chỉnh sửa",
    "렌더링 방식": "Chế độ hiển thị",
    "배경 + HTML/CSS 요소": "Nền + phần tử HTML/CSS",
    "이미지만 표시": "Chỉ hiển thị ảnh",
    "배경 이미지 맞춤": "Cách khớp ảnh nền",
    "COVER · 영역 채우기": "COVER · Lấp đầy vùng",
    "CONTAIN · 전체 표시": "CONTAIN · Hiển thị toàn bộ",
    "FILL · 강제 맞춤": "FILL · Kéo giãn để khớp",
    "배경 이미지": "Ảnh nền",
    "업로드 중...": "Đang tải lên...",
    "로컬 이미지 업로드": "Tải ảnh từ máy",
    "배경 제거": "Xóa nền",
    "업로드하면 /uploads/info-backgrounds/... 로 자동 입력됩니다.": "Sau khi tải lên, /uploads/info-backgrounds/... sẽ được điền tự động.",
    "요소 이미지 업로드 중...": "Đang tải ảnh phần tử lên...",
    "배경 이미지 미리보기": "Xem trước ảnh nền",
    "입력 내용이 미리보기에 자동 반영됨": "Nội dung nhập được tự động phản ánh trong phần xem trước",
    "언어별 문구 적용 완료 · {count}개 언어 감지": "Đã áp dụng nội dung theo ngôn ngữ · phát hiện {count} ngôn ngữ",
    "텍스트 {number}": "Văn bản {number}",
    "요소 이미지는 파일당 10MB 이하만 가능해.": "Mỗi tệp ảnh phần tử phải có dung lượng không quá 10MB.",
    "추가 텍스트": "Văn bản bổ sung",
    "요소 이미지": "Ảnh phần tử",
    "요소": "Phần tử",
    "배너 레이아웃·다국어 편집": "Bố cục banner · Chỉnh sửa đa ngôn ngữ",
    "각 텍스트 요소에 언어별 문구를 한 칸에 통으로 입력하고, 배경 외 장식 이미지도 로컬에서 추가할 수 있습니다.": "Nhập nội dung theo từng ngôn ngữ vào một ô cho mỗi phần tử văn bản, đồng thời có thể thêm ảnh trang trí từ máy riêng với ảnh nền.",
    "클라이언트 언어별 미리보기": "Xem trước theo ngôn ngữ client",
    "미리보기: {language}": "Xem trước: {language}",
    "번역이 없을 때 사용할 언어": "Ngôn ngữ dùng khi thiếu bản dịch",
    "기본: {language}": "Mặc định: {language}",
    "편집 화면 {value}%": "Khung chỉnh sửa {value}%",
    "확대된 캔버스에서 요소를 끌어 배치합니다. 좌표는 배너 내부 백분율로 저장되어 같은 기기 프로필 안에서 창 크기에 맞춰 함께 축소·확대됩니다.": "Kéo các phần tử trên canvas đã phóng to để bố trí. Tọa độ được lưu theo phần trăm bên trong banner, nên sẽ co giãn theo kích thước cửa sổ trong cùng cấu hình thiết bị.",
    "텍스트 요소별 통합 다국어 입력": "Nhập đa ngôn ngữ hợp nhất theo phần tử văn bản",
    "구분자는 줄바꿈, |, 쉼표를 사용할 수 있습니다. 예: 한국어:지금 바로 | 영어:Right now | 일본어:今すぐ": "Có thể dùng xuống dòng, | hoặc dấu phẩy làm dấu phân cách. Ví dụ: Tiếng Hàn:지금 바로 | Tiếng Anh:Right now | Tiếng Nhật:今すぐ",
    "언어별 찾아서 적용": "Phát hiện và áp dụng theo ngôn ngữ",
    "한국어:문구 | 영어:Text | 일본어:テキ스트": "Tiếng Hàn:문구 | Tiếng Anh:Text | Tiếng Nhật:テキスト",
    "추가 텍스트 요소": "Phần tử văn bản bổ sung",
    "+ 텍스트 요소 추가": "+ Thêm phần tử văn bản",
    "추가 텍스트가 없습니다. 필요한 개수만큼 요소를 추가하세요.": "Không có văn bản bổ sung. Hãy thêm số lượng phần tử cần thiết.",
    "한국어:지금 바로 | 영어:Right now": "Tiếng Hàn:지금 바로 | Tiếng Anh:Right now",
    "캔버스에서 이 텍스트 선택": "Chọn văn bản này trên canvas",
    "가로 중심": "Căn giữa ngang",
    "세로 중심": "Căn giữa dọc",
    "확대": "Tỷ lệ",
    "이미지 투명도": "Độ mờ ảnh",
    "텍스트 가독성 오버레이": "Lớp phủ tăng độ dễ đọc của văn bản",
    "요소 이미지 업로드": "Tải ảnh phần tử lên",
    "+ 로컬 이미지 추가": "+ Thêm ảnh từ máy",
    "배경과 별도로 로고, 카드, 칩, 아이콘 등을 여러 개 추가하고 각각 위치·크기를 조절할 수 있습니다.": "Có thể thêm nhiều logo, thẻ, chip, biểu tượng... riêng với nền và điều chỉnh vị trí, kích thước cho từng mục.",
    "이미지 요소": "Phần tử ảnh",
    "기본 요소 선택": "Chọn phần tử cơ bản",
    "{element} 위치·크기": "Vị trí · kích thước {element}",
    "너비": "Chiều rộng",
    "높이": "Chiều cao",
    "기준 글자 크기": "Cỡ chữ cơ sở",
    "투명도": "Độ mờ",
    "회전": "Xoay",
    "왼쪽": "Trái",
    "가운데": "Giữa",
    "오른쪽": "Phải",
    "글자색": "Màu chữ",
    "이미지 맞춤": "Khớp ảnh",
    "전체 표시 · contain": "Hiển thị toàn bộ · contain",
    "영역 채우기 · cover": "Lấp đầy vùng · cover",
    "강제 맞춤 · fill": "Kéo giãn để khớp · fill",
    "클라이언트에 표시": "Hiển thị trên client",
    "이 텍스트 요소 삭제": "Xóa phần tử văn bản này",
    "이 이미지 요소 삭제": "Xóa phần tử ảnh này",
    "프로필 좌표 복사": "Sao chép tọa độ cấu hình",
    "{profile}에서 복사": "Sao chép từ {profile}",
    "링크는 http://, https:// 또는 / 로 시작하는 내부 경로여야 해.": "Liên kết phải bắt đầu bằng http://, https:// hoặc đường dẫn nội bộ bắt đầu bằng /.",
    "1 row = 1 area + 1 device + 1 country + 1 background image · 저장 1건은 별도의 광고 1건": "1 row = 1 area + 1 device + 1 country + 1 background image · Mỗi lần lưu là một quảng cáo riêng",
    "배너 렌더링 방식": "Chế độ hiển thị banner",
    "배경 이미지 + 다국어 HTML/CSS 요소": "Ảnh nền + phần tử HTML/CSS đa ngôn ngữ",
    "이미지 전체만 표시": "Chỉ hiển thị toàn bộ ảnh",
    "이미지 전체 표시 · contain": "Hiển thị toàn bộ ảnh · contain",
    "https://... 또는 /lounge": "https://... hoặc /lounge",
    "비워두면 이동 없음 · 외부 URL 또는 /lounge 같은 내부 경로 사용 가능": "Để trống thì không chuyển trang · Có thể dùng URL bên ngoài hoặc đường dẫn nội bộ như /lounge",
    "이미지 전체 표시 방식에서는 업로드한 이미지가 그대로 노출됩니다. 좌표·다국어 요소 편집은 배경 이미지 + HTML/CSS 방식을 선택할 때 사용합니다.": "Ở chế độ hiển thị toàn bộ ảnh, ảnh đã tải lên sẽ được hiển thị nguyên trạng. Chỉ dùng chỉnh sửa tọa độ và phần tử đa ngôn ngữ khi chọn chế độ Ảnh nền + HTML/CSS.",
    "저장 1건 = 별도의 광고 1건 · area/device/country별로 각각 관리": "Mỗi lần lưu = một quảng cáo riêng · quản lý riêng theo area/device/country",
    "배지": "Huy hiệu",
    "보상": "Phần thưởng",
    "설명": "Mô tả",
    "버튼": "Nút",
    "배지 상단": "Phía trên huy hiệu",
    "배지 하단": "Phía dưới huy hiệu",
    "강조 제목": "Tiêu đề nhấn mạnh",
    "보상 문구": "Nội dung phần thưởng"
  },
  th: {
    "/notice/123 또는 https://...": "/notice/123 หรือ https://...",
    "인포카드": "การ์ดข้อมูล",
    "인포카드 삭제": "ลบการ์ดข้อมูล",
    "인포카드 삭제 실패": "ลบการ์ดข้อมูลไม่สำเร็จ",
    "이 인포카드를 삭제하시겠습니까? 같은 카드의 데스크톱/모바일·언어별 변형도 함께 삭제됩니다. 테이블 그룹과 게임 테이블은 삭제되지 않습니다.": "ต้องการลบการ์ดข้อมูลนี้หรือไม่? เวอร์ชันเดสก์ท็อป/มือถือและเวอร์ชันตามภาษาของการ์ดเดียวกันจะถูกลบด้วย แต่กลุ่มโต๊ะและโต๊ะเกมจะไม่ถูกลบ",
    "에이전트 수수료 기본값 설정": "ตั้งค่าค่าธรรมเนียมเริ่มต้นของเอเยนต์",
    "추천 코드 가입과 하위 계정 자동 생성 시 적용할 기본 수수료율을 설정합니다.": "กำหนดอัตราค่าธรรมเนียมเริ่มต้นที่ใช้กับการสมัครผ่านรหัสแนะนำและการสร้างบัญชีระดับล่างอัตโนมัติ",
    "현재 계정": "บัญชีปัจจุบัน",
    "현재 수수료": "ค่าธรรมเนียมปัจจุบัน",
    "설정 상태": "สถานะการตั้งค่า",
    "미설정": "ยังไม่ได้ตั้งค่า",
    "설정됨": "ตั้งค่าแล้ว",
    "하위 에이전트 설정 방식": "รูปแบบการตั้งค่าเอเยนต์ระดับล่าง",
    "자율형과 고정 설정 중 하나를 선택합니다.": "เลือกแบบอิสระหรือแบบกำหนดตายตัว",
    "자율형": "แบบอิสระ",
    "직속 하위 에이전트에게 수수료율만 넘기고, 이후 하위 설정은 해당 에이전트가 직접 결정합니다.": "ส่งต่อเฉพาะอัตราค่าธรรมเนียมเริ่มต้นให้เอเยนต์ระดับล่างโดยตรง และให้เอเยนต์นั้นกำหนดการตั้งค่าระดับถัดไปเอง",
    "고정 설정": "กำหนดตายตัว",
    "현재 계정이 하위 에이전트와 유저 수수료를 모두 고정합니다. 하위 계정에는 설정 팝업이 표시되지 않습니다.": "บัญชีปัจจุบันจะกำหนดค่าธรรมเนียมของเอเยนต์ระดับล่างและผู้ใช้ทั้งหมด บัญชีระดับล่างจะไม่เห็นป๊อปอัปการตั้งค่า",
    "직속 유저": "ผู้ใช้โดยตรง",
    "자율형 기본값": "ค่าเริ่มต้นแบบอิสระ",
    "직속 하위 에이전트가 자동 생성될 때 적용할 최초 수수료율입니다.": "อัตราค่าธรรมเนียมเริ่มต้นที่ใช้เมื่อสร้างเอเยนต์ระดับล่างโดยตรงโดยอัตโนมัติ",
    "lv{from} → lv{to} 기본 수수료": "ค่าธรรมเนียมเริ่มต้น lv{from} → lv{to}",
    "하위 에이전트가 이후 자신의 하위 수수료를 직접 설정합니다.": "หลังจากนั้นเอเยนต์ระดับล่างจะกำหนดค่าธรรมเนียมของระดับที่อยู่ใต้ตนเอง",
    "lv4는 추가 하위 에이전트가 없어 유저 가입 기본값만 설정합니다.": "lv4 ไม่มีเอเยนต์ระดับล่างถัดไป จึงตั้งค่าเฉพาะค่าเริ่มต้นสำหรับการสมัครของผู้ใช้",
    "전체 고정 기본값": "ค่าเริ่มต้นแบบกำหนดตายตัวทั้งหมด",
    "하위 계정이 생성되는 레벨에 따라 아래 값을 자동 적용합니다.": "ใช้ค่าด้านล่างโดยอัตโนมัติตามระดับของบัญชีระดับล่างที่ถูกสร้าง",
    "lv{level} 고정 수수료": "ค่าธรรมเนียมคงที่ lv{level}",
    "자동 생성되는 lv{level} 에이전트 노드에 적용됩니다.": "ใช้กับโหนดเอเยนต์ lv{level} ที่สร้างอัตโนมัติ",
    "유저 고정 레이크백": "เรคแบ็กผู้ใช้แบบคงที่",
    "고정 체인 아래에 생성되는 모든 신규 유저 노드에 적용됩니다.": "ใช้กับโหนดผู้ใช้ใหม่ทั้งหมดที่สร้างภายใต้สายแบบคงที่",
    "고정 하위 경로 합계": "ผลรวมเส้นทางระดับล่างแบบคงที่",
    "유저 회원가입 타입": "ประเภทการสมัครผู้ใช้",
    "유저가 현재 에이전트의 추천 코드를 통해 직접 가입할 때 적용됩니다.": "ใช้เมื่อผู้ใช้สมัครโดยตรงผ่านรหัสแนะนำของเอเยนต์ปัจจุบัน",
    "추천인 가입 유저 기본 수수료": "ค่าธรรมเนียมเริ่มต้นของผู้ใช้ที่สมัครผ่านการแนะนำ",
    "고정 설정의 유저 값과 자동으로 동일하게 유지됩니다.": "จะถูกปรับให้เท่ากับค่าผู้ใช้ในโหมดกำหนดตายตัวโดยอัตโนมัติ",
    "lv{level} → 유저로 직접 연결될 때 적용됩니다.": "ใช้เมื่อผู้ใช้เชื่อมต่อโดยตรงภายใต้ lv{level}",
    "적용 방식": "วิธีการใช้งาน",
    "직접 가입 유저": "ผู้ใช้ที่สมัครโดยตรง",
    "상위 고정 정책이 적용된 하위 에이전트는 별도의 기본값 설정 팝업을 보지 않습니다.": "เอเยนต์ระดับล่างที่อยู่ภายใต้นโยบายคงที่ของระดับบนจะไม่เห็นป๊อปอัปตั้งค่าเริ่มต้นแยกต่างหาก",
    "하위 에이전트는 자신이 로그인한 뒤 다음 단계의 기본값을 별도로 설정할 수 있습니다.": "หลังจากเข้าสู่ระบบ เอเยนต์ระดับล่างสามารถตั้งค่าเริ่มต้นของระดับถัดไปแยกต่างหากได้",
    "수수료 기본값 저장에 실패했습니다.": "บันทึกค่าธรรมเนียมเริ่มต้นไม่สำเร็จ",
    "나중에 설정": "ตั้งค่าภายหลัง",
    "기본값 저장": "บันทึกค่าเริ่มต้น",
    "직접 입력": "กรอกเอง",
    "수수료 기본값 설정": "ตั้งค่าธรรมเนียมเริ่มต้น",
    "수수료 기본값 수정": "แก้ไขค่าธรรมเนียมเริ่มต้น",
    "상위 고정 설정 적용 중": "กำลังใช้การตั้งค่าคงที่จากระดับบน",
    "0.01 이상의 금액을 소수 둘째 자리까지 입력해 주세요.": "กรอกจำนวนตั้งแต่ 0.01 ขึ้นไป โดยมีทศนิยมไม่เกิน 2 ตำแหน่ง",
    "보유한 레이크백보다 큰 금액은 이동할 수 없습니다.": "ไม่สามารถโอนจำนวนที่มากกว่าเรคแบ็กที่มีอยู่ได้",
    "레이크백을 일반 자산으로 이동했습니다.": "โอนเรคแบ็กไปยังสินทรัพย์ทั่วไปแล้ว",
    "레이크백 이동에 실패했습니다.": "โอนเรคแบ็กไม่สำเร็จ",
    "자산으로 이동": "โอนไปยังสินทรัพย์",
    "레이크백 → 일반 자산": "เรคแบ็ก → สินทรัพย์ทั่วไป",
    "이동할 금액만큼 레이크백이 차감되고 일반 자산에 즉시 추가됩니다.": "จำนวนที่โอนจะถูกหักจากเรคแบ็กและเพิ่มไปยังสินทรัพย์ทั่วไปทันที",
    "보유 레이크백": "เรคแบ็กที่มีอยู่",
    "현재 일반 자산": "สินทรัพย์ทั่วไปปัจจุบัน",
    "이동 금액": "จำนวนที่โอน",
    "전액": "ทั้งหมด",
    "이동 중...": "กำลังโอน...",
    "소수 둘째 자리까지 입력 가능": "กรอกทศนิยมได้ไม่เกิน 2 ตำแหน่ง",
    "0.01 ~ 1,000,000,000.00 범위의 금액을 소수 둘째 자리까지 입력하세요.": "กรอกจำนวนระหว่าง 0.01 ถึง 1,000,000,000.00 โดยมีทศนิยมไม่เกิน 2 ตำแหน่ง",
    "유저": "ผู้ใช้",
    "디자인 이미지": "รูปภาพดีไซน์",
    "디자인": "ดีไซน์",
    "실제 비율 미리보기": "ดูตัวอย่างตามอัตราส่วนจริง",
    "결제 항목 금액은 0보다 크고 소수 둘째 자리까지만 입력할 수 있습니다.": "จำนวนเงินของรายการชำระต้องมากกว่า 0 และกรอกทศนิยมได้ไม่เกิน 2 ตำแหน่ง",
    "지급이 처리되지 않았습니다.": "การจ่ายยังไม่ได้รับการดำเนินการ",
    "차감이 처리되지 않았습니다.": "การหักยังไม่ได้รับการดำเนินการ",
    "단독 인포버튼": "ปุ่มข้อมูลแบบเดี่ยว",
    "단독 인포버튼 생성 실패": "สร้างปุ่มข้อมูลแบบเดี่ยวไม่สำเร็จ",
    "+ 인포버튼 단독 생성": "+ สร้างปุ่มข้อมูลแบบเดี่ยว",
    "인포버튼 단독 생성": "สร้างปุ่มข้อมูลแบบเดี่ยว",
    "현재 디자인 배치와 다국어 문구를 기본값으로 초기화할까요?": "รีเซ็ตเลย์เอาต์ดีไซน์และข้อความหลายภาษาปัจจุบันกลับเป็นค่าเริ่มต้นหรือไม่?",
    "이미지 파일만 업로드할 수 있습니다.": "อัปโหลดได้เฉพาะไฟล์รูปภาพเท่านั้น",
    "배경 이미지 업로드에 실패했습니다.": "อัปโหลดภาพพื้นหลังไม่สำเร็จ",
    "요소 이미지 업로드에 실패했습니다.": "อัปโหลดภาพองค์ประกอบไม่สำเร็จ",
    "이벤트 카드 디자인 · 광고 편집기 방식": "ดีไซน์การ์ดกิจกรรม · โหมดตัวแก้ไขโฆษณา",
    "하단 이벤트 카드 자체를 배경 이미지 + 자유 배치 + 요소 이미지 + 언어별 구분자 텍스트 방식으로 편집합니다.": "แก้ไขการ์ดกิจกรรมด้านล่างโดยใช้ภาพพื้นหลัง + การจัดวางอิสระ + ภาพองค์ประกอบ + ข้อความแยกตามภาษา",
    "기존 하이라이트 문구 불러오기": "โหลดข้อความไฮไลต์เดิม",
    "디자인 초기화": "รีเซ็ตดีไซน์",
    "새 디자인 사용": "ใช้ดีไซน์ใหม่",
    "편집 디바이스": "อุปกรณ์ที่แก้ไข",
    "렌더링 방식": "โหมดการแสดงผล",
    "배경 + HTML/CSS 요소": "พื้นหลัง + องค์ประกอบ HTML/CSS",
    "이미지만 표시": "แสดงเฉพาะรูปภาพ",
    "배경 이미지 맞춤": "การพอดีของภาพพื้นหลัง",
    "COVER · 영역 채우기": "COVER · เติมเต็มพื้นที่",
    "CONTAIN · 전체 표시": "CONTAIN · แสดงทั้งหมด",
    "FILL · 강제 맞춤": "FILL · ยืดให้พอดี",
    "배경 이미지": "ภาพพื้นหลัง",
    "업로드 중...": "กำลังอัปโหลด...",
    "로컬 이미지 업로드": "อัปโหลดรูปจากเครื่อง",
    "배경 제거": "ลบพื้นหลัง",
    "업로드하면 /uploads/info-backgrounds/... 로 자동 입력됩니다.": "เมื่ออัปโหลดแล้ว ระบบจะกรอก /uploads/info-backgrounds/... ให้อัตโนมัติ",
    "요소 이미지 업로드 중...": "กำลังอัปโหลดภาพองค์ประกอบ...",
    "배경 이미지 미리보기": "ตัวอย่างภาพพื้นหลัง",
    "입력 내용이 미리보기에 자동 반영됨": "ข้อมูลที่กรอกจะแสดงในตัวอย่างโดยอัตโนมัติ",
    "언어별 문구 적용 완료 · {count}개 언어 감지": "ใช้ข้อความตามภาษาแล้ว · ตรวจพบ {count} ภาษา",
    "텍스트 {number}": "ข้อความ {number}",
    "요소 이미지는 파일당 10MB 이하만 가능해.": "ภาพองค์ประกอบแต่ละไฟล์ต้องมีขนาดไม่เกิน 10MB",
    "추가 텍스트": "ข้อความเพิ่มเติม",
    "요소 이미지": "ภาพองค์ประกอบ",
    "요소": "องค์ประกอบ",
    "배너 레이아웃·다국어 편집": "เลย์เอาต์แบนเนอร์ · แก้ไขหลายภาษา",
    "각 텍스트 요소에 언어별 문구를 한 칸에 통으로 입력하고, 배경 외 장식 이미지도 로컬에서 추가할 수 있습니다.": "กรอกข้อความแต่ละภาษาไว้ในช่องเดียวของแต่ละองค์ประกอบข้อความ และสามารถเพิ่มภาพตกแต่งจากเครื่องแยกจากภาพพื้นหลังได้",
    "클라이언트 언어별 미리보기": "ดูตัวอย่างตามภาษาของไคลเอนต์",
    "미리보기: {language}": "ตัวอย่าง: {language}",
    "번역이 없을 때 사용할 언어": "ภาษาที่ใช้เมื่อไม่มีคำแปล",
    "기본: {language}": "ค่าเริ่มต้น: {language}",
    "편집 화면 {value}%": "หน้าจอแก้ไข {value}%",
    "확대된 캔버스에서 요소를 끌어 배치합니다. 좌표는 배너 내부 백분율로 저장되어 같은 기기 프로필 안에서 창 크기에 맞춰 함께 축소·확대됩니다.": "ลากองค์ประกอบบนแคนวาสที่ขยายเพื่อจัดวาง พิกัดจะถูกบันทึกเป็นเปอร์เซ็นต์ภายในแบนเนอร์ จึงย่อหรือขยายตามขนาดหน้าต่างภายใต้โปรไฟล์อุปกรณ์เดียวกัน",
    "텍스트 요소별 통합 다국어 입력": "กรอกหลายภาษาแบบรวมตามองค์ประกอบข้อความ",
    "구분자는 줄바꿈, |, 쉼표를 사용할 수 있습니다. 예: 한국어:지금 바로 | 영어:Right now | 일본어:今すぐ": "ใช้ขึ้นบรรทัดใหม่, | หรือเครื่องหมายจุลภาคเป็นตัวคั่นได้ ตัวอย่าง: เกาหลี:지금 바로 | อังกฤษ:Right now | ญี่ปุ่น:今すぐ",
    "언어별 찾아서 적용": "ตรวจจับและใช้ตามภาษา",
    "한국어:문구 | 영어:Text | 일본어:テキ스트": "เกาหลี:문구 | อังกฤษ:Text | ญี่ปุ่น:テキスト",
    "추가 텍스트 요소": "องค์ประกอบข้อความเพิ่มเติม",
    "+ 텍스트 요소 추가": "+ เพิ่มองค์ประกอบข้อความ",
    "추가 텍스트가 없습니다. 필요한 개수만큼 요소를 추가하세요.": "ไม่มีข้อความเพิ่มเติม โปรดเพิ่มองค์ประกอบตามจำนวนที่ต้องการ",
    "한국어:지금 바로 | 영어:Right now": "เกาหลี:지금 바로 | อังกฤษ:Right now",
    "캔버스에서 이 텍스트 선택": "เลือกข้อความนี้บนแคนวาส",
    "가로 중심": "กึ่งกลางแนวนอน",
    "세로 중심": "กึ่งกลางแนวตั้ง",
    "확대": "สเกล",
    "이미지 투명도": "ความทึบของรูปภาพ",
    "텍스트 가독성 오버레이": "โอเวอร์เลย์เพิ่มความอ่านง่ายของข้อความ",
    "요소 이미지 업로드": "อัปโหลดภาพองค์ประกอบ",
    "+ 로컬 이미지 추가": "+ เพิ่มรูปจากเครื่อง",
    "배경과 별도로 로고, 카드, 칩, 아이콘 등을 여러 개 추가하고 각각 위치·크기를 조절할 수 있습니다.": "สามารถเพิ่มโลโก้ การ์ด ชิป ไอคอน และรูปอื่นๆ หลายรายการแยกจากพื้นหลัง พร้อมปรับตำแหน่งและขนาดของแต่ละรายการได้",
    "이미지 요소": "องค์ประกอบรูปภาพ",
    "기본 요소 선택": "เลือกองค์ประกอบพื้นฐาน",
    "{element} 위치·크기": "ตำแหน่ง·ขนาดของ {element}",
    "너비": "ความกว้าง",
    "높이": "ความสูง",
    "기준 글자 크기": "ขนาดตัวอักษรพื้นฐาน",
    "투명도": "ความทึบ",
    "회전": "หมุน",
    "왼쪽": "ซ้าย",
    "가운데": "กึ่งกลาง",
    "오른쪽": "ขวา",
    "글자색": "สีข้อความ",
    "이미지 맞춤": "การพอดีของรูปภาพ",
    "전체 표시 · contain": "แสดงทั้งหมด · contain",
    "영역 채우기 · cover": "เติมเต็มพื้นที่ · cover",
    "강제 맞춤 · fill": "ยืดให้พอดี · fill",
    "클라이언트에 표시": "แสดงบนไคลเอนต์",
    "이 텍스트 요소 삭제": "ลบองค์ประกอบข้อความนี้",
    "이 이미지 요소 삭제": "ลบองค์ประกอบรูปภาพนี้",
    "프로필 좌표 복사": "คัดลอกพิกัดโปรไฟล์",
    "{profile}에서 복사": "คัดลอกจาก {profile}",
    "링크는 http://, https:// 또는 / 로 시작하는 내부 경로여야 해.": "ลิงก์ต้องขึ้นต้นด้วย http://, https:// หรือเป็นพาธภายในที่ขึ้นต้นด้วย /",
    "1 row = 1 area + 1 device + 1 country + 1 background image · 저장 1건은 별도의 광고 1건": "1 row = 1 area + 1 device + 1 country + 1 background image · การบันทึก 1 ครั้งคือโฆษณาแยก 1 รายการ",
    "배너 렌더링 방식": "โหมดการแสดงผลแบนเนอร์",
    "배경 이미지 + 다국어 HTML/CSS 요소": "ภาพพื้นหลัง + องค์ประกอบ HTML/CSS หลายภาษา",
    "이미지 전체만 표시": "แสดงเฉพาะภาพเต็ม",
    "이미지 전체 표시 · contain": "แสดงภาพทั้งหมด · contain",
    "https://... 또는 /lounge": "https://... หรือ /lounge",
    "비워두면 이동 없음 · 외부 URL 또는 /lounge 같은 내부 경로 사용 가능": "เว้นว่างไว้เพื่อไม่ให้เปลี่ยนหน้า · ใช้ URL ภายนอกหรือพาธภายใน เช่น /lounge ได้",
    "이미지 전체 표시 방식에서는 업로드한 이미지가 그대로 노출됩니다. 좌표·다국어 요소 편집은 배경 이미지 + HTML/CSS 방식을 선택할 때 사용합니다.": "ในโหมดแสดงภาพเต็ม รูปที่อัปโหลดจะแสดงตามเดิม การแก้ไขพิกัดและองค์ประกอบหลายภาษาใช้เมื่อเลือกโหมดภาพพื้นหลัง + HTML/CSS",
    "저장 1건 = 별도의 광고 1건 · area/device/country별로 각각 관리": "การบันทึก 1 ครั้ง = โฆษณาแยก 1 รายการ · จัดการแยกตาม area/device/country",
    "배지": "ป้าย",
    "보상": "รางวัล",
    "설명": "คำอธิบาย",
    "버튼": "ปุ่ม",
    "배지 상단": "ด้านบนป้าย",
    "배지 하단": "ด้านล่างป้าย",
    "강조 제목": "ชื่อเรื่องเน้น",
    "보상 문구": "ข้อความรางวัล"
  }
};

export default phase2Completion;
